// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ANcc","left":"styles_left__6NBCw","desktopActions":"styles_desktopActions__3tuZU","title":"styles_title__3SqXg"};